import { Button, Card, Col, DatePicker, Input, Row } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { GUTTOR_SPACE_SMALL } from '../../constants/commonConstants';
import { SearchOutlined } from '@ant-design/icons';
import { searchClicked, setFilter } from '../../../store/actions/abdmHiuAction';

const FilterDropdownComponentForAbha = (props: any): ReactElement => {
  const {
    filterKey, searchFilterKey, setSelectedKeys, inputType, placeholder,
    } = props;
  const dispatch = useDispatch();
  const selectedFilters = useSelector((state: RootState): any => state.abdmHiu.searchFilters);
  const { RangePicker } = DatePicker;

  useEffect((): any => {
    setSelectedKeys(selectedFilters[searchFilterKey]);
  }, [selectedFilters]);

  const onSearch = (): any => {
    dispatch(searchClicked());
  };

  const inputChangeHandler = (event: any): void => {
    dispatch(setFilter({ [searchFilterKey]: event.target.value }));
    if (event.target.value === '' ) {
      dispatch(searchClicked());
    }
  };

  const dateOnChange = (event: any): any => {
    dispatch(setFilter({ [searchFilterKey]: event }));
    if (event === null) {
      dispatch(searchClicked());    }
  };

  const getInputField = (): ReactElement | null => {
    switch (inputType) {
      case 'TEXT':
        return (
          <Row className="custom-amount-range">
            <Col>
              <Input
                placeholder={placeholder}
                allowClear={true}
                size="middle"
                onChange={inputChangeHandler}
                value={selectedFilters[searchFilterKey]}
                data-testid={filterKey}
                className="input-field"
                onPressEnter={onSearch}
              />
            </Col>
            <Col md={2}>
              <Button type="primary" icon={<SearchOutlined />} className="search-btn" onClick={onSearch} />
            </Col>
          </Row>
        );
      case 'DATE_RANGE':
        return (
          <Row className="custom-amount-range">
            <Col md={20} className="text-input">
              <RangePicker
                allowClear={true}
                onChange={dateOnChange}
                value={selectedFilters[searchFilterKey]}
                className="no-right-border-radius-rangepicker"
              />
            </Col>
            <Col md={4}>
              <Button type="primary" icon={<SearchOutlined />} className="w-100" onClick={onSearch}/>
            </Col>
          </Row>
        );
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <Card className="in-patient-filter-dropdown">
        <Row gutter={GUTTOR_SPACE_SMALL}>
          <Col md={24}>
            {getInputField()}
          </Col>
        </Row>
      </Card>
    </React.Fragment>);
  };

export default FilterDropdownComponentForAbha;
